module.exports = __webpack_public_path__ + "img/banner.dc5d9982.png";